<div
    class="success-modal-overlay"
    [class.show]="show"
    (click)="onClose()"
>
    <div
        class="success-modal-card"
        (click)="$event.stopPropagation()"
    >
        <div class="success-icon-wrap">
            <div class="success-icon" [class.animate]="show">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="check-icon"
                    [class.animate]="show"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="3"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M5 13l4 4L19 7"
                    />
                </svg>
            </div>
        </div>
        <h2 class="success-title" [class.animate]="show">{{ title }}</h2>
        <p class="success-message" [class.animate]="show">
            {{ message }}
        </p>
        <button
            (click)="onClose()"
            class="success-btn"
            [class.animate]="show"
        >
            Tutup
        </button>
    </div>
</div>
